import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const messages = {
        hu: {
            siteName: 'Silver River - EU Ragnaros',
            language: 'Nyelv',
            languages: {
                hu: 'Magyar',
                en: 'Angol'
            },
            common: {
                edit: 'Szerkesztés',
                create: 'Létrehozás',
                delete: 'Törlés',
                view: 'Megtekintés'
            },
            pages: {
                index: 'Főoldal',
                login: 'Bejelentkezés',
                signUp: 'Regisztráció',
                introduction: 'Rólunk',
                achievements: 'Eredményeink',
                tgf: 'Tagfelvétel',
                rules: 'Klán Szabályzat',
                comingSoon: 'Hamarosan',
                admin: 'Admin',
                logout: 'Kijelentkezés'
            },
            navBar: {
                menu: 'Menü',
                siteNamePopover: ''
            },
            introduction: {
                title: 'Rólunk',
                subtitle: ''
            },
            login: {
                email: 'E-mail cím',
                password: 'Jelszó',
                loginbtn: 'Bejelentkezés',
                create: 'Új felhasználó',
                needhelp: 'Elfelejtett jelszó?'
            },
            register: {
                name: 'Név',
                email: 'E-mail cím',
                password: 'Jelszó',
                passwordAgain: 'Jelszó megerősítése',
                registerbtn: 'Regisztráció',
                login: 'Bejelentkezés',
                needhelp: 'Elfelejtett jelszó?'
            },
            needhelp: {
                email: 'E-mail cím',
                resetbtn: 'Jelszó visszaállítása'
            },
            footer: {
                createdBy: 'Készítette:'
            },
            authaction: {
                newPasswordBtn: 'Jelszó beállítása'
            },
            messages: {
                error: 'Hiba',
                unexpected_error: 'Váratlan hiba történt! Ha továbbra is fennáll, kérlek vedd fel velünk a kapcsolatot, hogy kijavíthassuk!',
                name_length_error: 'Kérlek adj meg egy nevet 2-64 karakter között!',
                email_invalid: 'Hibás e-mail cím formátum!',
                password_invalid: 'Hibás jelszó forma! Legyen 8-32 karakter hosszú, tartalmazzon legalább egy nagy és kisbetűt, valamint egy számot!',
                invalid_request: 'Váratlan hiba történt!',
                email_empty: 'Az e-mail cím mező üres!',
                password_empty: 'A jelszó mező üres!',
                password_doesnt_match: 'A két jelszó nem egyezik!',
                user_not_found: 'Felhasználó nem található ilyen e-mail címmel!',
                wrong_password: 'Hibás jelszó!',
                email_already_in_use: 'Ezzel az e-mail címmel már regisztráltak!',
                register_success: 'Sikeres regisztráció! Kérlek erősítsd meg az e-mail címed belépés előtt!',
                user_not_verified: 'Kérlek erősítsd meg az e-mail címed belépés előtt!',
                auth_invalid_action_code: 'A link hibás, elavult vagy már fel lett használva!',
                aszf_error: 'Az Általános Szerződési Feltételeket és Adatvédelmi Szabályzatot el kell fogadni a regisztrációhoz!'
            },
            userRole: {
                admin: 'Admin',
                premium: 'Prémium',
                normal: 'Ingyenes'
            }
        },
        en: {
            siteName: 'Silver River - EU Ragnaros',
            language: 'Language',
            languages: {
                hu: 'Hungarian',
                en: 'English'
            },
            pages: {
                index: 'Home',
                login: 'Log in',
                signUp: 'Sign up',
                introduction: 'Introduction',
                achievements: 'Achievements',
                rules: 'Guild Rules',
                tgf: 'Recruitment',
                comingSoon: 'Coming soon',
                logout: 'Log out'
            },
            navBar: {
                menu: 'Menu',
                siteNamePopover: ''
            },
            common: {
                edit: 'Edit',
                create: 'Create',
                delete: 'Delete',
                view: 'View'
            },
            introduction: {
                title: 'Introduction',
                subtitle: ''
            },
            login: {
                email: 'E-mail address',
                password: 'Password',
                loginbtn: 'Login',
                create: 'Create account',
                needhelp: 'Forgot password?'
            },
            register: {
                name: 'Name',
                email: 'E-mail address',
                password: 'Password',
                passwordAgain: 'Confirm password',
                registerbtn: 'Create account',
                login: 'Log in',
                needhelp: 'Forgot password?'
            },
            needhelp: {
                email: 'E-mail address',
                resetbtn: 'Reset password'
            },
            authaction: {
                newPasswordBtn: 'Set password'
            },
            footer: {
                createdBy: 'Created by'
            },
            messages: {
                error: 'Error',
                unexpected_error: 'Unexpected error! If the error lasts, please contact us, so we can fix the problem!',
                name_length_error: 'Please enter a name with 2-64 characters!',
                email_invalid: 'Invalid e-mail address format!',
                password_invalid: 'Invalid password! 8-32 characters, must contain at least one uppercase letter, one lowercase letter and one number!',
                invalid_request: 'Invalid request!',
                email_empty: 'Empty e-mail address!',
                password_empty: 'Empty password!',
                password_doesnt_match: 'The passwords doesn\'t match!',
                user_not_found: 'User not found with this e-mail!',
                wrong_password: 'Incorrect password!',
                email_already_in_use: 'This e-mail is already registered!',
                register_success: 'Successful registration! Please verify your e-mail address!',
                user_not_verified: 'Please verify your e-mail address!',
                auth_invalid_action_code: 'The link is invalid, expired or had been used already!'
            }
        }
    }
;

export const i18n = new VueI18n({
    locale: 'hu',
    messages,
});
